import { render, staticRenderFns } from "./TemplateLists.vue?vue&type=template&id=4789be7a&scoped=true&"
import script from "./TemplateLists.vue?vue&type=script&lang=js&"
export * from "./TemplateLists.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLists.vue?vue&type=style&index=0&id=4789be7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789be7a",
  null
  
)

export default component.exports